import binaryData from "./raw/binary.json";
import binaryInterval from "./raw/binary_in.json";

export const BinaryColorMap = (type) => {
  if (type === "interval") {
    return binaryInterval;
  }
  if (type === "range") {
    return binaryData;
  }
};
